export default "__VITE_ASSET__Epw8AgxL__"